export default __webpack_public_path__ + "static/media/FAQ_11_1.69d35dda.png";